import { useTranslation } from "react-i18next";

export function SearchingIndicator(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2">
      <span className="size-1.5 animate-pulse rounded-full bg-ds-slate-700" />
      <span className="text-[10px] font-medium uppercase tracking-widest text-ds-slate-700">
        {t("Searching…")}
      </span>
    </div>
  );
}
